/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Create_KeyInputs */

const en_settings_apikeys_create_key = /** @type {(inputs: Settings_Apikeys_Create_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Key`)
};

/**
* | output |
* | --- |
* | "Create Key" |
*
* @param {Settings_Apikeys_Create_KeyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_create_key = /** @type {((inputs?: Settings_Apikeys_Create_KeyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Create_KeyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_create_key(inputs)
});
export { settings_apikeys_create_key as "settings.apikeys.create_key" }